type LogFn = (...args: unknown[]) => void;

/** `__DEV__` es global en React Native; en Node tests puede no estar definida. */
declare const __DEV__: boolean | undefined;
const isDev = typeof __DEV__ !== 'undefined' && __DEV__;

const noop: LogFn = () => {};

/** Logs de diagnóstico: solo visibles cuando __DEV__ es true. */
export const devLog: LogFn = isDev ? (...args) => console.log(...args) : noop;
export const devInfo: LogFn = isDev ? (...args) => console.info(...args) : noop;
export const devWarn: LogFn = isDev ? (...args) => console.warn(...args) : noop;

export function silenceConsoleInProduction(): void {
  if (isDev) return;
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}
